import { SHA256nymudvmltc47 as SHA256 } from '../../../../hash-library-sha2/org/kotlincrypto/hash/sha2/SHA256.mjs';
import {
  hash1fp34sezu95cc as hash,
  hash2teqor7x28bwm as hash_0,
  hash1az8j7xdn0ud6 as hash_1,
  hash1973x73wcw20i as hash_2,
  hashdslf6mgodcq4 as hash_3,
} from './Bit32Digest.ext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Default_getInstance5ktjwh40tq1j as Default_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/io/encoding/Base64.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function hash_4(_this__u8e3s4) {
  var digest = SHA256().j53();
  hash(digest, _this__u8e3s4.a72_1);
  hash(digest, _this__u8e3s4.b72_1);
  hash(digest, _this__u8e3s4.c72_1);
  hash(digest, _this__u8e3s4.d72_1);
  hash_0(digest, _this__u8e3s4.e72_1);
  hash_1(digest, _this__u8e3s4.f72_1);
  hash_2(digest, _this__u8e3s4.g72_1);
  hash_3(digest, _this__u8e3s4.l72_1);
  hash_0(digest, _this__u8e3s4.m72_1);
  return Default_getInstance().rq(digest.g51());
}
//region block: exports
export {
  hash_4 as hash2c804431zmucg,
};
//endregion

//# sourceMappingURL=PendingItemChange.ext.mjs.map
